import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-analytics',
  templateUrl: './icon-analytics.component.html',
  styleUrls: ['./icon-analytics.component.scss']
})
export class IconAnalyticsComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
